import React from 'react';

interface Props {
  messageId: string;
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ESAMessageErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown): void {
    console.error(`[ESAMessageErrorBoundary] Message ${this.props.messageId} failed to render`, error);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          aria-label="Message render error"
          data-message-id={this.props.messageId}
          className="px-3 py-1.5 text-error text-caption italic"
        >
          This message could not be rendered.
        </div>
      );
    }
    return this.props.children;
  }
}
